export default {
  primary: '#8257E5',

  text: '#454545',
  titleText: '#FFFFFF',
  badgeText: '#FFFFFF',

  background: '#F2F2F2',
  cardHeader: '#04BF58',
  cardBackground: '#FBFBFB',
  badgeItems: '#E33D3D',

  line: '#C4C4C4'
};
